export default {
    regular: {
      minHeight: '52px !important',
    }
  };